import React, { Component } from "react";
import {
  DropdownButton,
  MenuItem,
  FormGroup,
  Col,
  ControlLabel,
  ButtonGroup
} from "react-bootstrap";

const BUTTONS = ["Default", "Primary", "Success", "Info", "Warning", "Danger"];
const styles = {
  customWidth: {
    width: 100 + "%"
  }
};

export class KeyValueDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: this.props.proprieties[0].defaultValue
        ? this.getTitle(this.props.proprieties[0].defaultValue)
        : this.props.proprieties[0].placeholder
    };
    this.onSelect = this.onSelect.bind(this);
  }

  onSelect = eventKey => {
    var title = this.getTitle(eventKey);
    this.setState({title: title});
    
    this.props.onValueChange(eventKey,this.props.statekey);
  };

  getTitle = (val) => {
    if(this.props.formatter) {
      var selectedValue = this.props.proprieties[0].children.find((item,key)=>{
        let itemKey = Object.keys(item)[0];
        return itemKey==val;
      });
      if(selectedValue) {
        return this.props.formatter(selectedValue[val]);
      }
    } else if(this.props.keyvalue && this.props.keytext) {
      var selectedValue = this.props.proprieties[0].children.find((item,key)=>{
        let itemKey = item[this.props.keyvalue];
        return itemKey==val;
      });
      if(selectedValue && selectedValue[this.props.keytext]) {
        return selectedValue[this.props.keytext];
      }
    }
    return val;
  }

  render() {
    const { hidden } = this.props;
    var row = [];
    var style = {};
    if(hidden===true) {
      style.display = 'none';
    }
    for (var i = 0; i < this.props.ncols.length; i++) {
      row.push(
        <div key={i} className={this.props.ncols[i]}>
          {/* <FieldGroup {...this.props.proprieties[i]} /> */}

          <FormGroup style={{ marginBottom: -10 + "px" }}>
            <Col
              componentClass={ControlLabel}
              style={{ marginTop: 5 + "px" }}
              md={5}
            >
              {this.props.proprieties[i].label}
            </Col>
            <Col md={7}>
              <ButtonGroup justified>
                <DropdownButton
                  style={{ width: 100 + "%" }}
                  bsStyle="default"
                  bsSize="xsmall"
                  title={this.state.title}
                  key={1}
                  id={`dropdown-basic`}
                  disabled={this.props.disabled}
                >
                  {this.props.proprieties[i].children.map((item,key) => {
                        let eth = Object.keys(item)[0];
                        let ethval = null;
                        let value = item[eth];
                        if(this.props.formatter) {
                          ethval = this.props.formatter(value);
                        } else {
                          ethval = eth;
                        }
                        if(this.props.keyvalue && item[this.props.keyvalue]) {
                          eth = item[this.props.keyvalue];
                        }
                        if(this.props.keytext && item[this.props.keytext]) {
                          ethval = item[this.props.keytext];
                        }
                    return (
                      <MenuItem
                        eventKey={eth}
                        onSelect={this.onSelect}
                        key={key}
                        // active
                      >
                        {ethval}
                      </MenuItem>
                    );
                  })}
                </DropdownButton>
              </ButtonGroup>
            </Col>
          </FormGroup>
        </div>
      );
    }
    return <div style={style}>{row}</div>;
  }
}

export default KeyValueDropdown;
